var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8441_207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8441_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5003 13.3815C6.96505 13.3815 6.51073 13.1948 6.13733 12.8214C5.76394 12.448 5.57724 11.9937 5.57724 11.4584C5.57724 10.9232 5.76394 10.4688 6.13733 10.0955C6.51073 9.72205 6.96505 9.53535 7.5003 9.53535C8.03555 9.53535 8.48988 9.72205 8.86328 10.0955C9.23667 10.4688 9.42337 10.9232 9.42337 11.4584C9.42337 11.9937 9.23667 12.448 8.86328 12.8214C8.48988 13.1948 8.03555 13.3815 7.5003 13.3815ZM4.42341 17.9167C4.00246 17.9167 3.64616 17.7709 3.35449 17.4792C3.06283 17.1876 2.91699 16.8313 2.91699 16.4103V5.25653C2.91699 4.83559 3.06283 4.47928 3.35449 4.18762C3.64616 3.89595 4.00246 3.75012 4.42341 3.75012H5.57726V2.6283C5.57726 2.44562 5.63843 2.29312 5.76076 2.17078C5.88308 2.04846 6.03559 1.9873 6.21828 1.9873C6.40096 1.9873 6.55347 2.04846 6.6758 2.17078C6.79812 2.29312 6.85928 2.44562 6.85928 2.6283V3.75012H13.1734V2.61228C13.1734 2.43494 13.2332 2.28644 13.3528 2.16678C13.4725 2.04713 13.621 1.9873 13.7983 1.9873C13.9757 1.9873 14.1242 2.04713 14.2438 2.16678C14.3635 2.28644 14.4233 2.43494 14.4233 2.61228V3.75012H15.5772C15.9981 3.75012 16.3545 3.89595 16.6461 4.18762C16.9378 4.47928 17.0836 4.83559 17.0836 5.25653V16.4103C17.0836 16.8313 16.9378 17.1876 16.6461 17.4792C16.3545 17.7709 15.9981 17.9167 15.5772 17.9167H4.42341ZM4.42341 16.6668H15.5772C15.6413 16.6668 15.7001 16.6401 15.7535 16.5866C15.8069 16.5332 15.8336 16.4744 15.8336 16.4103V8.58987H4.16697V16.4103C4.16697 16.4744 4.19368 16.5332 4.2471 16.5866C4.30053 16.6401 4.3593 16.6668 4.42341 16.6668Z",
    fill: "#323232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.17db932f5a4436300b4e209646648936.svg";
export { ForwardRef as ReactComponent };